import React from 'react';
import { ArticleDetail } from '../components/articles/ArticleDetail';
import { careerArticles } from '../data/articles';

export default function ArticleCarrierePage() {
  return <ArticleDetail articles={careerArticles} section="carriere" />;
}